import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  TourDeleteInput,
  TourModel,
  TourMutationInput,
  TourUpdateInput,
} from './model';

export function useCreateTour(
  options?: UseMutationOptions<
    ApiResult<TourModel>,
    ApiError,
    TourMutationInput
  >,
): UseMutationResult<ApiResult<TourModel>, ApiError, TourMutationInput> {
  return useMutation<ApiResult<TourModel>, ApiError, TourMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'tours',
        method: 'POST',
        classType: TourModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateTour(
  options?: UseMutationOptions<ApiResult<TourModel>, ApiError, TourUpdateInput>,
): UseMutationResult<ApiResult<TourModel>, ApiError, TourUpdateInput> {
  return useMutation<ApiResult<TourModel>, ApiError, TourUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/${body.tourId}`,
        method: 'PUT',
        classType: TourModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useCancelTour(
  options?: UseMutationOptions<{ message: string }, ApiError, TourDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, TourDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/${body.tourId}/cancel`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useCloseTour(
  options?: UseMutationOptions<{ message: string }, ApiError, TourDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, TourDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/${body.tourId}/close`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useUncloseTour(
  options?: UseMutationOptions<{ message: string }, ApiError, TourDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, TourDeleteInput> {
  return useMutation<{ message: string }, ApiError, TourDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `tours/${body.tourId}/revert-close`,
        method: 'PATCH',
      });
    },
    options,
  );
}
